import { Tabs } from '@mantine/core';
import { ISection } from '../../interfaces/Section';
import classes from './SectionsTabs.module.css';
import { memo } from 'react';
import SkeletonLine from '../Skeletons/SkeletonLine';
import CardLoaderSkeletonGridRows from '../Skeletons/CardLoaderSkeletonGridRows';

const SectionTabList = memo(
  ({ sections }: { sections: ISection[] }) => {
    return (
      <Tabs.List
        grow
        mb={10}
        bg={'white'}
        style={{
          borderRadius: 'var(--mantine-radius-xl)',
          boxShadow: 'var(--mantine-shadow-xl)'
        }}>
        {sections.map((section) => {
          return (
            <Tabs.Tab
              key={section._id}
              w={'20%'}
              color={section.boxColor}
              value={section._id || ''}
              fw={'bold'}
              // leftSection={<IconCategory style={{ width: rem(16), height: rem(16) }} />}
            >
              {section.name.toUpperCase()}
            </Tabs.Tab>
          );
        })}
      </Tabs.List>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.sections === nextProps.sections;
  }
);

export default function SectionsTabs({
  sections = [],
  activeTab,
  setActiveTab,
  children,
  loading = false
}: {
  sections: ISection[];
  children: any;
  activeTab: string | null;
  setActiveTab: any;
  loading?: boolean;
}) {
  if (loading) {
    return (
      <>
        <SkeletonLine />
        <SkeletonLine />
        <SkeletonLine />
        <CardLoaderSkeletonGridRows cardsQty={3} cardContentRows={8} />
      </>
    );
  }
  return (
    <>
      <Tabs
        value={activeTab}
        onChange={setActiveTab}
        classNames={classes}
        variant="pills"
        keepMounted={false}
        radius={'xl'}>
        <SectionTabList sections={sections} />
        {children}
      </Tabs>
    </>
  );
}
